var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RhfFieldError, rhfMapperReq, useController, } from '@isyc-react/form/modules/rhf';
import { ParameterType, ParameterVisualizationMode } from '@isyc-react/types';
import { InputParameter, } from '@isyc-react/oncustomer/modules/objects/parameter';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { components } from 'react-select';
export const validBailleursParameter = (dataValue, data) => {
    if (!(data === null || data === void 0 ? void 0 : data.obligatory))
        return true;
    switch (data === null || data === void 0 ? void 0 : data.parameterType) {
        case ParameterType.BOOLEAN_TYPE:
            return true;
        case ParameterType.DECIMAL_TYPE:
        default:
            return Boolean(dataValue);
    }
};
export const getParameterDisabled = (data, readOnly, disabled) => Boolean(readOnly) || Boolean(disabled);
export const RhfInputBailleursParameter = props => {
    var _a;
    const { rhf, errorMessage, input, remarks, async = false } = props;
    const { field: { onChange, onBlur, name, value, ref }, fieldState: { error }, } = useController(rhfMapperReq(rhf, (p) => Boolean(p.value), {
        valid: (p) => validBailleursParameter(p.value, p),
    }));
    const required = (_a = rhf.rules) === null || _a === void 0 ? void 0 : _a.required;
    const data = value;
    const CustomOption = (_a) => {
        var { children } = _a, props = __rest(_a, ["children"]);
        // eslint-disable-next-line no-unused-vars
        const _b = props.innerProps, { onMouseMove, onMouseOver } = _b, rest = __rest(_b, ["onMouseMove", "onMouseOver"]);
        const newProps = Object.assign(Object.assign({}, props), { innerProps: rest });
        return (React.createElement(components.Option, Object.assign({}, newProps), children));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: 'form-label' },
            data.label,
            " ",
            (data.obligatory || required) && React.createElement("span", { className: 'required' }, "*"),
            (remarks || data.remarks) && (React.createElement(OverlayTrigger, { delay: { show: 250, hide: 0 }, overlay: React.createElement(Tooltip, null, remarks || data.remarks) },
                React.createElement("i", { className: 'mdi mdi-information text-light-secondary ms-2' })))),
        React.createElement("div", null,
            React.createElement(InputParameter, Object.assign({ onChange: onChange, onBlur: onBlur, value: value, data: Object.assign({ visualizationMode: ParameterVisualizationMode.COMBO }, data), error: Boolean(error), getDisabled: getParameterDisabled, async: async }, input, { virtualization: true, virtualizationThreshold: 30 })),
            React.createElement(RhfFieldError, { errorMessage: errorMessage, error: error }))));
};
